module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('hamv-dialog', {
    attrs: {
      "dialogProps": _vm.dialogProps,
      "showModal": _vm.showModal
    }
  }, [_c('span', {
    staticClass: "el-dialog__title",
    attrs: {
      "slot": "header",
      "data-qa": "Dialog-UploadInformationModel-Title"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.$t('informationModelUploadDialogTitle')))]), _vm._v(" "), _c('el-form', {
    ref: "data",
    attrs: {
      "model": _vm.data,
      "id": "uploadform",
      "enctype": "multipart/form-data",
      "label-position": "left"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, _vm._l((_vm.fieldsData), function(field, key) {
    return _c('el-form-item', {
      key: key,
      attrs: {
        "data-qa": ("Dialog-UploadInformationModelUpload-" + key),
        "label-width": _vm.labelWidth,
        "label": field.label
      }
    }, [_c('div', {
      staticClass: "upload-block"
    }, [_c('input', _vm._b({
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: (field.validate),
        expression: "field.validate"
      }],
      staticClass: "input-file",
      attrs: {
        "id": field.name,
        "name": field.name,
        "accept": ".json,.yaml,.yml",
        "data-qa": ("Dialog-UploadInformationModelUpload" + key + "-UploadField"),
        "multiple": "",
        "type": "file"
      },
      on: {
        "change": function($event) {
          _vm.filesChange(key, $event.target.name, $event.target.files)
        }
      }
    }, 'input', field.model, false)), _vm._v(" "), _c('label', {
      staticClass: "el-button el-button--default",
      attrs: {
        "for": field.name
      }
    }, [_vm._v(_vm._s(_vm.$t('informationModelUploadButtonUploadText')))]), _vm._v(" "), _c('div', {
      staticClass: "selected-file-name"
    }, [_vm._v(_vm._s(field.selectedFileName))])]), _vm._v(" "), (_vm.errors.has(field.name)) ? _c('div', {
      staticClass: "help is-danger"
    }, [_vm._v("\n        " + _vm._s(_vm.$t('informationModelUploadInputUploadError')) + "\n      ")]) : _vm._e()])
  })), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer-content"
    },
    slot: "footer-content"
  }, [_c('el-alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.alert$.show),
      expression: "alert$.show"
    }],
    attrs: {
      "closable": false,
      "type": _vm.alert$.type,
      "data-qa": "Dialog-UploadInformationModel-Alert",
      "show-icon": "",
      "title": ""
    }
  }, _vm._l((_vm.alert$.errors), function(error, index) {
    return _c('p', {
      key: index
    }, [_vm._v("\n        " + _vm._s(error) + "\n      ")])
  }))], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "actions"
    },
    slot: "actions"
  }, [_c('el-button', {
    staticClass: "btn-close",
    attrs: {
      "data-qa": "Dialog-UploadInformationModel-Button-Close",
      "type": "text"
    },
    on: {
      "click": _vm.closePopup
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelUploadDialogButtonCloseText')) + "\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "disabled": _vm.loading || _vm.errors.any(),
      "loading": _vm.loading,
      "data-qa": "Dialog-UploadInformationModel-Button-Upload",
      "type": "warning"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('informationModelUploadDialogButtonUploadText')) + "\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23b4224a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InformationModelUpload/InformationModelUpload.vue
// module id = 958
// module chunks = 3